import { component, prop } from '../../../decorators';

import OpenerMixin from '../../../mixins/opener.mixin';

import extend from 'lodash/extend';
import some from 'lodash/some';
import find from 'lodash/find';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import head from 'lodash/head';
import isNil from 'lodash/isNil';
import constant from 'lodash/constant';

const DEFAULT_OPTIONS = Object.freeze({
   showSelectedValue: true,
   closeOnSelect: true,
   selectFirstIfEmpty: false,

   optionKey: 'value',
   optionLabel: 'label',
   optionOptions: {},

   defaultLabel: ''
});


@component({
   mixins: [ OpenerMixin ],
   watch: {
      initValue: 'onChangeInitValue',
      list: 'onChangeList'
   }
})
export default class Select {
   @prop({}) initValue
   @prop({ type: Object, default: constant({}) }) selectOptions
   @prop({ type: Array, required: true }) list
   @prop({ type: Boolean, default: false }) disabled

   selected = null
   opts = {}

   get label() {
      if ( this.opts.showSelectedValue && this.selected ) {
         return this.optionLabel(this.selected);
      }
      return this.opts.defaultLabel;
   }

   select(opt) {
      this.selected = opt;
      this.$emit('change', this._opt2val(opt));
      if (this.opts.closeOnSelect) {
         this.deactivate();
      }
   }

   optionLabel(opt) {
      return _convertOpt2Primitive(opt, this.opts.optionLabel);
   }

   _opt2val(opt) {
      return _convertOpt2Primitive(opt, this.opts.optionKey);
   }

   mounted() {
      if ( !isNil(this.initValue) ) {
         this.selected = find(this.list, o => this.initValue === this._opt2val(o));
      } else if ( this.opts.selectFirstIfEmpty ) {
         this.select(head(this.list));
      }
   }

   onChangeInitValue(initValue) {
      this.selected = find(this.list, o => initValue === this._opt2val(o));
   }

   onChangeList(list) {
      // eslint-disable-next-line no-magic-numbers
      if (list.length === 1) {
         this.$nextTick(() => this.select(head(list)));
         return;
      }

      if (this.selected) {
         const val = this._opt2val(this.selected);
         if (some(list, o => val === this._opt2val(o))) {
            return;
         }  else if ( this.opts.selectFirstIfEmpty ) {
            this.$nextTick(() => this.select(head(list)));
            return;
         }

         this.selected = null;
         this.$emit('change', null);
      } else if (this.initValue) {
         this.selected = find(this.list, o => this.initValue === this._opt2val(o));
      } else if ( this.opts.selectFirstIfEmpty ) {
         this.$nextTick(() => this.select(head(list)));
      }
   }

   created() {
      this.opts = extend({}, DEFAULT_OPTIONS, this.selectOptions);
   }
}

function _isPrimitive(val) {
   return some([isString, isNumber], fnc => fnc(val));
}

function _convertOpt2Primitive(opt, key) {
   if ( _isPrimitive(opt) ) {
      return opt;
   }

   return opt[key];
}
